import * as React from "react";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  contractManagementPath,
  Context,
  createSchoolOrderChangeRequest,
  fetchInitialData,
  CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import RegistrationNumChangeRequestForm from "../../../templates/manager/RegistrationNumChangeRequestForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [isDone, setIsDone] = React.useState(false);

  React.useEffect(() => {
    if (
      state.success_message ===
      CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS_MESSAGE
    ) {
      dispatch(clearSuccessMessage());
      setIsDone(true);
    }
  }, [dispatch, state.success_message]);

  const submitRequest = React.useCallback(
    (
      changes: {
        entrance_year: number;
        dlp_registrable_num: number;
        g4s_registrable_num: number;
        teaching_material_names: string[];
      }[],
      reason: string,
    ) => {
      dispatch(peep(createSchoolOrderChangeRequest(changes, reason)));
    },
    [dispatch, peep],
  );

  // 直リロード時はManagerAppがsession_id確定時にinitial_dataを取得するため二重発火になる。
  // 取得済み（=画面内遷移で開いた）場合のみ、人数を最新化する目的で再取得する
  React.useEffect(() => {
    if (state.manager.id) {
      dispatch(fetchInitialData());
    }
    return () => dispatch(clearErrorMessage());
    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.contractManagement, to: contractManagementPath },
        ]}
        currentTitle={titles.registrationNumChangeRequest}
      />
      <RegistrationNumChangeRequestForm
        school={state.manager.school}
        calling={calling}
        error={state.error}
        isDone={isDone}
        submitRequest={submitRequest}
        isMasqueradeByAdmin={state.isMasqueradeByAdmin}
      />
    </div>
  );
};
